// List here all possible dynamic range keywords, consumer is limited to use only existing options
export enum DateRangeKeyword {
	Today = 'today',
	Tomorrow = 'tomorrow',
	NextTwoDays = 'next_two_days',
	LateOrders = 'late_orders',
	Last7Days = 'last_7_days',
	Last30Days = 'last_30_days',
	LastMonth = 'last_month'
}
